import { useSelector } from "react-redux";
import { createSelector } from "reselect";

const selectUserPermissions = createSelector(
    state => {
      const roles = state.authme.data?.roles;
      if (!roles || roles.length === 0 || !roles[0].permessions) {
        return null; // Return null instead of a new array
      }
      return roles[0].permessions;
    },
    permessions => permessions ? permessions.map(perm => perm.name) : []
  );



function usePermissions() {
 const userPermissions = useSelector(selectUserPermissions);

//check for permissions 

 const hasPermission = (permission) => userPermissions.includes(permission);

 const checkPermissionAndThrow = (permission) => {
   if (!hasPermission(permission)) {
     return false;
   }
   else{
     return true;
   }
 };    


return { checkPermissionAndThrow  }; 
    
}

export default usePermissions;  